import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { withStyles, CircularProgress, Fab, Tooltip } from '@material-ui/core';
import { Check as CheckIcon, Close as CloseIcon, Edit as EditIcon } from '@material-ui/icons';

class FormEditButton extends PureComponent {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        formDisabled: PropTypes.bool.isRequired,
        handleEdit: PropTypes.func.isRequired,
        confirmEdit: PropTypes.func.isRequired,
        sendLoading: PropTypes.bool.isRequired,
        positionClassName: PropTypes.string,
        useSecondaryPosition: PropTypes.bool
    };

    static defaultProps = {
        positionClassName: null,
        useSecondaryPosition: false
    };

    render() {
        const { classes, formDisabled, handleEdit, confirmEdit, sendLoading, positionClassName, useSecondaryPosition } = this.props;
        const positionClass = useSecondaryPosition ? classes.secondaryPosition : positionClassName ? positionClassName : classes.firstPosition;
        if (sendLoading)
            return (
                <div className={positionClass}>
                    <CircularProgress size={25} />
                </div>
            );
        return (
            <div className={positionClass}>
                {formDisabled ? (
                    <Tooltip title={Translator.translate('general.edit')} placement="top">
                        <Fab
                            className={`${classes.btnEdit} ${classes.fabEdit}`}
                            aria-label={Translator.translate('general.edit')}
                            size="small"
                            onClick={handleEdit}
                        >
                            <EditIcon className={classes.icon} />
                        </Fab>
                    </Tooltip>
                ) : (
                    <Fragment>
                        <Tooltip title={Translator.translate('general.cancel')} placement="top">
                            <Fab
                                aria-label={Translator.translate('general.cancel')}
                                className={`${classes.btnEdit} ${classes.fabCancel}`}
                                size="small"
                                onClick={handleEdit}
                            >
                                <CloseIcon className={classes.icon} />
                            </Fab>
                        </Tooltip>
                        <Tooltip title={Translator.translate('general.save')} placement="top">
                            <Fab
                                aria-label={Translator.translate('general.save')}
                                className={`${classes.btnEdit} ${classes.fabSave}`}
                                size="small"
                                onClick={confirmEdit}
                            >
                                <CheckIcon className={classes.icon} />
                            </Fab>
                        </Tooltip>
                    </Fragment>
                )}
            </div>
        );
    }
}

const styles = theme => ({
    firstPosition: {
        position: 'absolute',
        top: 50,
        right: 50,
        [theme.breakpoints.down('md')]: {
            top: 30,
            right: 30
        },
        [theme.breakpoints.down('sm')]: {
            top: 20,
            right: 20
        },
        [theme.breakpoints.down('xs')]: {
            top: 18,
            right: 18
        }
    },

    secondaryPosition: {
        position: 'absolute',
        top: 15,
        right: 60
    },
    fabEdit: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white
    },
    fabSave: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white
    },
    fabCancel: {
        backgroundColor: theme.palette.common.white,
        color: theme.palette.error.main
    },
    btnEdit: {
        marginLeft: 10,
        minHeight: 30,
        minWidth: 30,
        [theme.breakpoints.down('xs')]: {
            height: 30,
            width: 30
        }
    },
    icon: {
        [theme.breakpoints.down('xs')]: {
            fontSize: '1.2rem'
        }
    }
});

export default withStyles(styles, { withTheme: true })(FormEditButton);



// WEBPACK FOOTER //
// ./data/components/FormEditButton.js